const columns = [
  {
    name: "Name Options",
    selector: (row) => row.name,
    sortable: true,
    maxWidth: "200px",
  },
  {
    name: "Part of",
    selector: (row) => row.partId?.name || "-",
    sortable: true,
    maxWidth: "200px",
  },
  {
    name: "Type Parts",
    selector: (row) => row.partId?.type || "-",
    sortable: true,
    maxWidth: "200px",
  },
  // {
  //   name: "Icon",
  //   selector: (row) => row.icon,
  //   sortable: true,
  //   maxWidth: "200px",
  //   format: (row) => {
  //     return row.icon ? (
  //       <img
  //         src={row.icon}
  //         alt={row.name}
  //         style={{
  //           height: "40px",
  //           width: "40px",
  //           objectFit: "cover",
  //           borderRadius: "4px",
  //         }}
  //       />
  //     ) : (
  //       "-"
  //     );
  //   },
  // },
  // {
  //   name: "Product",
  //   selector: (row) =>
  //     row.detailProduct === null ? "-" : row.detailProduct.name,
  //   sortable: true,
  //   maxWidth: "200px",
  // },
];

export default columns;
